// Catalogue initial : exercices originaux et deux mélodies (une traditionnelle du domaine
// public, une originale). Les doigtés sont indicatifs et devront être relus par un
// professeur (V3 du plan). Tout est écrit avec la notation compacte de builder.ts.

import { PPQ, type Score } from './model';
import { part } from './builder';

const ORIGINAL = 'Composition originale pianoHome, libre d’utilisation dans l’application';

export const CATALOG: Score[] = [
  {
    id: 'md-cinq-doigts',
    title: 'Cinq doigts, main droite',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 1,
    tags: ['main droite', 'position de do', 'noires'],
    description: 'La main droite en position de do : le pouce sur le do central, un doigt par touche. Montez puis redescendez sans regarder vos mains.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 72,
    minTempo: 40,
    parts: [part('right', 'C4:q/1 D4:q/2 E4:q/3 F4:q/4 | G4:q/5 F4:q/4 E4:q/3 D4:q/2 | C4:w/1')],
  },
  {
    id: 'mg-cinq-doigts',
    title: 'Cinq doigts, main gauche',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 1,
    tags: ['main gauche', 'position de do', 'noires'],
    description: 'La main gauche en position de do : l’auriculaire sur le do grave, le pouce sur le sol. Descendez puis remontez.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 72,
    minTempo: 40,
    parts: [part('left', 'C3:q/5 D3:q/4 E3:q/3 F3:q/2 | G3:q/1 F3:q/2 E3:q/3 D3:q/4 | C3:w/5')],
  },
  {
    id: 'md-notes-repetees',
    title: 'Notes répétées',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 1,
    tags: ['main droite', 'répétition', 'régularité'],
    description: 'Quatre frappes par note, bien détachées. Chaque frappe doit être reconnue séparément : un bon test pour le micro.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 80,
    minTempo: 40,
    parts: [part('right', 'C4:q/1 C4:q/1 C4:q/1 C4:q/1 | D4:q/2 D4:q/2 D4:q/2 D4:q/2 | E4:q/3 E4:q/3 E4:q/3 E4:q/3 | C4:w/1')],
  },
  {
    id: 'md-tenues-silences',
    title: 'Tenues et silences',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 1,
    tags: ['main droite', 'blanches', 'rondes', 'silences'],
    description: 'Tenez chaque note sur toute sa durée, puis laissez le silence exister. Comptez à voix haute : un, deux, trois, quatre.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 76,
    minTempo: 40,
    parts: [part('right', 'C4:h/1 r:h | E4:h/3 r:h | G4:w/5 | r:h C4:h/1')],
  },
  {
    id: 'md-tierces',
    title: 'Sauts de tierce',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 2,
    tags: ['main droite', 'tierces', 'lecture'],
    description: 'On saute une touche à chaque fois. Gardez la main souple, sans la déplacer.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 76,
    minTempo: 40,
    parts: [part('right', 'C4:q/1 E4:q/3 D4:q/2 F4:q/4 | E4:q/3 G4:q/5 F4:q/4 D4:q/2 | E4:h/3 C4:h/1')],
  },
  {
    id: 'mains-alternees',
    title: 'Mains en alternance',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 2,
    tags: ['deux mains', 'rondes', 'coordination'],
    description: 'Une main après l’autre, une ronde chacune. Préparez la main suivante pendant que l’autre joue.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 80,
    minTempo: 40,
    parts: [
      part('right', 'C4:w/1 | r:w | E4:w/3 | r:w | G4:w/5 | r:w'),
      part('left', 'r:w | C3:w/5 | r:w | G3:w/1 | r:w | C3:w/5'),
    ],
  },
  {
    id: 'md-valse-simple',
    title: 'Petite valse à trois temps',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 2,
    tags: ['main droite', 'trois temps', 'blanche pointée'],
    description: 'Une mesure à trois temps : un temps fort, deux temps légers. La blanche pointée dure toute la mesure.',
    ppq: PPQ,
    timeSignature: { beats: 3, beatUnit: 4 },
    keyFifths: 0,
    tempo: 96,
    minTempo: 50,
    parts: [
      part(
        'right',
        'C4:q/1 E4:q/3 G4:q/5 | E4:h/3 C4:q/1 | D4:q/2 F4:q/4 G4:q/5 | F4:h/4 D4:q/2 | C4:q/1 E4:q/3 G4:q/5 | E4:q/3 D4:q/2 C4:q/1 | D4:h/2 D4:q/2 | C4:h./1',
      ),
    ],
  },
  {
    id: 'mg-accords',
    title: 'Accords de la main gauche',
    subtitle: 'MIDI recommandé',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'exercise',
    level: 3,
    tags: ['main gauche', 'accords', 'MIDI'],
    description: 'Trois notes ensemble, puis un renversement. Le micro de la V1 ne sépare pas les notes simultanées : préférez une connexion MIDI pour cet exercice.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 72,
    minTempo: 40,
    parts: [part('left', '[C3/5 E3/3 G3/1]:h [C3/5 E3/3 G3/1]:h | [B2/5 D3/3 G3/1]:h [B2/5 D3/3 G3/1]:h | [C3/5 E3/3 G3/1]:w')],
  },
  {
    id: 'piece-au-clair-de-la-lune',
    title: 'Au clair de la lune',
    subtitle: 'Traditionnel',
    author: 'Traditionnel français (XVIIIe siècle), arrangement pianoHome',
    license: 'Mélodie du domaine public ; arrangement libre d’utilisation dans l’application',
    kind: 'piece',
    level: 1,
    tags: ['mélodie', 'deux mains', 'domaine public'],
    description: 'La mélodie à la main droite, une note de basse par mesure à la main gauche. Commencez par la main droite seule, puis ajoutez la gauche.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 84,
    minTempo: 40,
    parts: [
      part(
        'right',
        // Phrase A (deux fois), phrase B, phrase A. Doigtés indicatifs : main en position de do, puis
        // déplacement sur sol3-ré4 pour la phrase B (5 4 3 2 1), à faire relire par un professeur.
        'C4:q/1 C4:q/1 C4:q/1 D4:q/2 | E4:h/3 D4:h/2 | C4:q/1 E4:q/3 D4:q/2 D4:q/2 | C4:w/1 | ' +
          'C4:q/1 C4:q/1 C4:q/1 D4:q/2 | E4:h/3 D4:h/2 | C4:q/1 E4:q/3 D4:q/2 D4:q/2 | C4:w/1 | ' +
          'D4:q/5 D4:q/5 D4:q/5 D4:q/5 | A3:h/2 A3:h/2 | D4:q/5 C4:q/4 B3:q/3 A3:q/2 | G3:w/1 | ' +
          'C4:q/1 C4:q/1 C4:q/1 D4:q/2 | E4:h/3 D4:h/2 | C4:q/1 E4:q/3 D4:q/2 D4:q/2 | C4:w/1',
      ),
      part(
        'left',
        'C3:w/5 | G3:w/1 | C3:h/5 G3:h/1 | C3:w/5 | ' +
          'C3:w/5 | G3:w/1 | C3:h/5 G3:h/1 | C3:w/5 | ' +
          'G3:w/1 | F3:w/2 | G3:w/1 | G3:w/1 | ' +
          'C3:w/5 | G3:w/1 | C3:h/5 G3:h/1 | C3:w/5',
      ),
    ],
  },
  {
    id: 'piece-promenade',
    title: 'Promenade en do',
    subtitle: 'Mélodie originale',
    author: 'pianoHome',
    license: ORIGINAL,
    kind: 'piece',
    level: 2,
    tags: ['mélodie', 'deux mains', 'original'],
    description: 'Huit mesures en do majeur. La main droite se promène sur cinq notes, la main gauche pose une basse par mesure.',
    ppq: PPQ,
    timeSignature: { beats: 4, beatUnit: 4 },
    keyFifths: 0,
    tempo: 84,
    minTempo: 40,
    parts: [
      part(
        'right',
        'C4:q/1 D4:q/2 E4:q/3 G4:q/5 | E4:q/3 D4:q/2 C4:h/1 | D4:q/2 E4:q/3 F4:q/4 A4:q/5 | F4:q/4 E4:q/3 D4:h/2 | ' +
          'G4:q/5 G4:q/5 F4:q/4 E4:q/3 | D4:q/2 E4:q/3 F4:q/4 D4:q/2 | C4:q/1 E4:q/3 G4:q/5 E4:q/3 | C4:w/1',
      ),
      part('left', 'C3:w/5 | G3:w/1 | F3:w/2 | G3:w/1 | C3:w/5 | G3:w/1 | C3:h/5 G3:h/1 | C3:w/5'),
    ],
  },
];

export function findScore(id: string): Score | undefined {
  return CATALOG.find((s) => s.id === id);
}
